import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import { CommentEditorContext } from '../../../CommentEditor/context';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import s from './LazyPlaceholder.scss';
/**
 * What we'll show instead of the editor if the DaEditor chunk isn't loaded yet.
 *
 * It's a button that'll trigger the chunk to load.
 */ const LazyPlaceholder = ()=>{
    const { t } = useTranslation();
    const { editorSource } = useContext(CommentEditorContext);
    const { triggerProps } = useContext(LoadableComponentContext);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: s['root']
    }, triggerProps), editorSource === CommentEditorSource.Reply ? t('commentbox.editor.placeholder.reply') : t('commentbox.editor.placeholder'));
};
LazyPlaceholder.displayName = 'LazyPlaceholder';
export default LazyPlaceholder;
